import request from '../../../helpers/request';
import { useQuery } from 'react-query';
import { getQueryKeys } from './queryKeys';

const getTransportCountries = async () => {
  return await request.get(
    '/HousingStock/transport/country',
    {},
    'При загрузке стран произошла ошибка',
    []
  );
};

const useTransportCountries = (options = {}) =>
  useQuery(getQueryKeys.transportCountries(), getTransportCountries, options);

export default useTransportCountries;